export default __webpack_public_path__ + "static/media/desktop_78.50e7434a.jpg";